import { ErrorHandler, Injectable } from "@angular/core";
import { BrdLoggerService } from "@board/cloud-library/components/services";
import { ApplicationInsightsService } from "@board/cloud-library/components/services";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private logger: BrdLoggerService,
    private appInsights: ApplicationInsightsService
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleError(error: any): void {
    this.logger.error(error.message, error.correlation);

    const err: Error = error instanceof Error ? error : new Error(typeof error === "string" ? error : JSON.stringify(error));
    this.appInsights.logError(err, { correlation: error?.correlation });
  }
}
